import React, { HTMLAttributeAnchorTarget } from 'react';
import { LinkComponent } from './Link.styles';
import mixpanel from 'mixpanel-browser';
import { onlyText } from 'react-children-utilities';

export type LinkVariants = 'regular' | 'button' | 'thick' | 'outline';
export type LinkSizes = 'sm' | 'md' | 'lg';

export interface LinkProps {
  children: React.ReactNode;
  href: string;
  variant?: LinkVariants;
  className?: string;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
  size?: LinkSizes;
}

const Link = ({ className, children, href, variant, ...rest }: LinkProps) => {
  return (
    <LinkComponent
      className={className}
      href={href}
      variant={variant}
      {...rest}
      onMouseDown={(e) => {
        const name = onlyText(children);
        mixpanel.track('LinkClicked', { name, href });
      }}
    >
      {children}
    </LinkComponent>
  );
};

export default Link;
